import { render, staticRenderFns } from "./BigTitle.vue?vue&type=template&id=21df88f3&scoped=true&"
import script from "./BigTitle.vue?vue&type=script&lang=js&"
export * from "./BigTitle.vue?vue&type=script&lang=js&"
import style0 from "./BigTitle.vue?vue&type=style&index=0&id=21df88f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21df88f3",
  null
  
)

export default component.exports